import PublicGraduatePledgeFormPage from "./pages/PublicGraduatePledgeFormPage";
import PublicGraduatePledgeStatusPage from "./pages/PublicGraduatePledgeStatusPage";
import AdminGraduatePledgePage from "./pages/AdminGraduatePledgePage";
import AdminGraduatePledgeCohortsPage from "./pages/AdminGraduatePledgeCohortsPage";

/**
 * The student's form is genuinely public — no layout, no guard, no session.
 * It is mounted alongside the event card-verify page rather than in the
 * private list, because a final-year student opening a QR code has no account
 * and must never be bounced to /login.
 *
 * The path is short and typeable on purpose: it goes on departmental notices
 * and into class WhatsApp groups, where people retype it.
 */
export const publicGraduatePledgeRoutes = [
  { path: "/graduate-pledge", element: <PublicGraduatePledgeFormPage /> },

  // The student's own record, by the token in their email. Declared before
  // the bare /status path only for legibility — the two cannot collide, since
  // one has a second segment and the other does not.
  { path: "/graduate-pledge/status/:token", element: <PublicGraduatePledgeStatusPage /> },

  // Same page with no token: the "I have lost the email" box, which shows
  // nothing and emails the link instead.
  { path: "/graduate-pledge/status", element: <PublicGraduatePledgeStatusPage /> },
];

/**
 * The secretariat's side, on its own permission rather than the admin role.
 * These records belong to people who are not members and consented to their
 * data being used for one ceremony, so access is granted by name.
 *
 * Setting up a cohort additionally needs `graduate.pledge.manage` on the API;
 * the page is reachable on `access` so a clerk can read the cut-off and the
 * institution list, and the writes behind it refuse on their own.
 */
export const graduatePledgeRoutes = [
  {
    path: "/admin/graduate-pledge",
    element: <AdminGraduatePledgePage />,
    perms: ["graduate.pledge.access"],
  },
  {
    path: "/admin/graduate-pledge/cohorts",
    element: <AdminGraduatePledgeCohortsPage />,
    perms: ["graduate.pledge.access"],
  },
];
